export class InvMasterSerialEntity {

    id:number;
    serial:string;
    mac:string;
    userId:number;
    creationDate:string;
    status:string;
    active:boolean;
    palletId:number;
    location:string;
    codigoSap:string;
    typology:string;
    pallet:string;
    validation:string;
    total:string;
    name:string;
    missingFound:string;
    missing:string;
    spareFound:string;
    spare:string;
    constructor() { }
}